:host {
  display: block;
  margin-bottom: 0.75rem;
  height: auto;
}

.rating-count-stars {
  font-size: 0.875rem;
  line-height: 0.875rem;
  font-family: var(--cms-font-trade-gothic);
  display: inline-block;
  margin-left: 4px;
}

.no-rating-article {
  color: var(--cms-dark-grey);
  margin-bottom: 0.75rem;
  font-size: 0.75rem;
}

.ratings-container {
  display: flex;
  align-items: center;
}
